import usaFlag from "../assets/images/usa-flag.svg";
import bannerStrandTop from "../assets/images/banner-strand-top.png";
import bannerStrandBottom from "../assets/images/banner-strand-bottom-left.png";
import prophylacticVaccinesIcon from "../assets/images/prophylactic-vaccines-icon.png";
import noteScroll from "../assets/images/note-scroll.png";

export const faqPageData = {
      faqBannerData: {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'n9bebhw263o0'
            }
          },
          id: '7FSPIxBv2f8DUuOYNyjN2f',
          type: 'Entry',
          createdAt: '2022-10-25T05:36:06.733Z',
          updatedAt: '2023-06-16T18:23:48.072Z',
          environment: {
            sys: {
              id: 'sandbox',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          publishedVersion: 21,
          revision: 4,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'bannerComponent'
            }
          },
          locale: 'en-US'
        },
        fields: {
          title: 'FAQs',
          headline: 'Browse answers to frequently asked questions',
          backgroundImage: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'n9bebhw263o0'
                }
              },
              id: '5zfGJA7or5WGcLdYi4Qde',
              type: 'Asset',
              createdAt: '2022-10-28T18:53:29.208Z',
              updatedAt: '2022-10-28T18:53:29.208Z',
              environment: {
                sys: {
                  id: 'sandbox',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              publishedVersion: 6,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Banner BG Strand Top',
              description: '',
              file: {
                url: bannerStrandTop,
                details: {
                  size: 47693,
                  image: {
                    width: 1920,
                    height: 511
                  }
                },
                fileName: 'Banner BG Strand Top .png',
                contentType: 'image/png'
              }
            }
          },
          country: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'n9bebhw263o0'
                }
              },
              id: '7sht7920U6vs3CLH2CUyaa',
              type: 'Entry',
              createdAt: '2023-05-18T03:23:50.744Z',
              updatedAt: '2023-05-24T22:55:23.250Z',
              environment: {
                sys: {
                  id: 'sandbox',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              publishedVersion: 6,
              revision: 2,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'country'
                }
              },
              locale: 'en-US'
            },
            fields: {
              name: 'United States',
              isocode: 'US',
              flag: {
                metadata: {
                  tags: [],
                  concepts: []
                },
                sys: {
                  space: {
                    sys: {
                      type: 'Link',
                      linkType: 'Space',
                      id: 'n9bebhw263o0'
                    }
                  },
                  id: '3aYCbZJiL8aoEKRdhjOXyy',
                  type: 'Asset',
                  createdAt: '2023-05-24T22:54:50.939Z',
                  updatedAt: '2023-05-24T22:54:50.939Z',
                  environment: {
                    sys: {
                      id: 'sandbox',
                      type: 'Link',
                      linkType: 'Environment'
                    }
                  },
                  publishedVersion: 5,
                  revision: 1,
                  locale: 'en-US'
                },
                fields: {
                  title: 'usa flag',
                  description: 'USA Flag',
                  file: {
                    url: usaFlag,
                    details: {
                      size: 2487,
                      image: {
                        width: 36,
                        height: 26
                      }
                    },
                    fileName: 'usa_flag.svg',
                    contentType: 'image/svg+xml'
                  }
                }
              },
              locales: [
                'en-US'
              ]
            }
          }
        }
      },
      contactUsData: {
        metadata: {
          tags: [],
          concepts: []
        },
        sys: {
          space: {
            sys: {
              type: 'Link',
              linkType: 'Space',
              id: 'n9bebhw263o0'
            }
          },
          id: '6gqCKf6EtK3mI0yNzKHx5h',
          type: 'Entry',
          createdAt: '2022-10-28T20:10:43.478Z',
          updatedAt: '2022-10-31T05:40:26.928Z',
          environment: {
            sys: {
              id: 'sandbox',
              type: 'Link',
              linkType: 'Environment'
            }
          },
          publishedVersion: 12,
          revision: 3,
          contentType: {
            sys: {
              type: 'Link',
              linkType: 'ContentType',
              id: 'contactUsCta'
            }
          },
          locale: 'en-US'
        },
        fields: {
          contactUsMessage: 'Still can\'t find what you are looking for?',
          contactUsButtonLabel: 'CONTACT US',
          contactUsLink: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'n9bebhw263o0'
                }
              },
              id: '4HqZvZWcCaClANwXQS032G',
              type: 'Entry',
              createdAt: '2022-10-28T14:47:04.805Z',
              updatedAt: '2022-10-28T22:28:28.481Z',
              environment: {
                sys: {
                  id: 'sandbox',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              publishedVersion: 8,
              revision: 3,
              contentType: {
                sys: {
                  type: 'Link',
                  linkType: 'ContentType',
                  id: 'internalLink'
                }
              },
              locale: 'en-US'
            },
            fields: {
              title: 'Contact Us Link',
              label: 'Contact Us',
              pageReference: {
                metadata: {
                  tags: [],
                  concepts: []
                },
                sys: {
                  space: {
                    sys: {
                      type: 'Link',
                      linkType: 'Space',
                      id: 'n9bebhw263o0'
                    }
                  },
                  id: '6aA4Kfs006hNINMMIje8Cq',
                  type: 'Entry',
                  createdAt: '2022-10-28T20:09:14.397Z',
                  updatedAt: '2022-12-02T04:38:06.055Z',
                  environment: {
                    sys: {
                      id: 'sandbox',
                      type: 'Link',
                      linkType: 'Environment'
                    }
                  },
                  publishedVersion: 16,
                  revision: 3,
                  contentType: {
                    sys: {
                      type: 'Link',
                      linkType: 'ContentType',
                      id: 'page'
                    }
                  },
                  locale: 'en-US'
                },
                fields: {
                  name: 'Contact Us',
                  title: 'Contact Us',
                  slug: 'contact-us',
                  seo: {
                    metadata: {
                      tags: [],
                      concepts: []
                    },
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'n9bebhw263o0'
                        }
                      },
                      id: '3SZXCHhkMg78hB0DVPqLnA',
                      type: 'Entry',
                      createdAt: '2022-10-28T20:09:14.497Z',
                      updatedAt: '2022-10-28T20:09:14.497Z',
                      environment: {
                        sys: {
                          id: 'sandbox',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      publishedVersion: 15,
                      revision: 1,
                      contentType: {
                        sys: {
                          type: 'Link',
                          linkType: 'ContentType',
                          id: 'seo'
                        }
                      },
                      locale: 'en-US'
                    },
                    fields: {
                      name: 'Contact Us - Compose: SEO',
                      title: 'Contact Us Moderna',
                      description: 'Contact Us Moderna',
                      no_index: false,
                      no_follow: false
                    }
                  },
                  content: {
                    metadata: {
                      tags: [],
                      concepts: []
                    },
                    sys: {
                      space: {
                        sys: {
                          type: 'Link',
                          linkType: 'Space',
                          id: 'n9bebhw263o0'
                        }
                      },
                      id: '2XyGZ6yTIb3AUfSz6gUGfw',
                      type: 'Entry',
                      createdAt: '2022-10-28T20:09:14.520Z',
                      updatedAt: '2022-12-02T04:37:00.701Z',
                      environment: {
                        sys: {
                          id: 'sandbox',
                          type: 'Link',
                          linkType: 'Environment'
                        }
                      },
                      publishedVersion: 18,
                      revision: 4,
                      contentType: {
                        sys: {
                          type: 'Link',
                          linkType: 'ContentType',
                          id: 'pageContactUsPageTemplate'
                        }
                      },
                      locale: 'en-US'
                    },
                    fields: {
                      name: 'Contact Us - Contact Us Page Template',
                      modules: [
                        {
                          metadata: {
                            tags: [],
                            concepts: []
                          },
                          sys: {
                            space: {
                              sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                              }
                            },
                            id: '2y5JNbGCdLulrhbyD0VSZ5',
                            type: 'Entry',
                            createdAt: '2022-12-02T04:34:18.506Z',
                            updatedAt: '2023-09-22T16:32:41.034Z',
                            environment: {
                              sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                              }
                            },
                            publishedVersion: 39,
                            revision: 6,
                            contentType: {
                              sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'bannerComponent'
                              }
                            },
                            locale: 'en-US'
                          },
                          fields: {
                            title: 'Contact Us Banner Component',
                            headline: 'Contact Us',
                            backgroundImage: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '5zfGJA7or5WGcLdYi4Qde',
                                type: 'Asset',
                                createdAt: '2022-10-28T18:53:29.208Z',
                                updatedAt: '2022-10-28T18:53:29.208Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 6,
                                revision: 1,
                                locale: 'en-US'
                              },
                              fields: {
                                title: 'Banner BG Strand Top',
                                description: '',
                                file: {
                                  url: bannerStrandTop,
                                  details: {
                                    size: 47693,
                                    image: {
                                      width: 1920,
                                      height: 511
                                    }
                                  },
                                  fileName: 'Banner BG Strand Top .png',
                                  contentType: 'image/png'
                                }
                              }
                            },
                            message: 'Ready to order or have questions? We\'re here to help. Contact us for any guidance or information you need. Your satisfaction is our priority and we eagerly await the opportunity to serve you.',
                            country: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'ContentType',
                                    id: 'country'
                                  }
                                },
                                locale: 'en-US'
                              },
                              fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                  metadata: {
                                    tags: [],
                                    concepts: []
                                  },
                                  sys: {
                                    space: {
                                      sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                      }
                                    },
                                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                                    type: 'Asset',
                                    createdAt: '2023-05-24T22:54:50.939Z',
                                    updatedAt: '2023-05-24T22:54:50.939Z',
                                    environment: {
                                      sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                      }
                                    },
                                    publishedVersion: 5,
                                    revision: 1,
                                    locale: 'en-US'
                                  },
                                  fields: {
                                    title: 'usa flag',
                                    description: 'USA Flag',
                                    file: {
                                      url: usaFlag,
                                      details: {
                                        size: 2487,
                                        image: {
                                          width: 36,
                                          height: 26
                                        }
                                      },
                                      fileName: 'usa_flag.svg',
                                      contentType: 'image/svg+xml'
                                    }
                                  }
                                },
                                locales: [
                                  'en-US'
                                ]
                              }
                            }
                          }
                        },
                        {
                          metadata: {
                            tags: [],
                            concepts: []
                          },
                          sys: {
                            space: {
                              sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                              }
                            },
                            id: 'bZN3ozoAd7NgLj1g3GLIQ',
                            type: 'Entry',
                            createdAt: '2022-12-02T04:25:12.254Z',
                            updatedAt: '2024-05-28T21:10:01.634Z',
                            environment: {
                              sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                              }
                            },
                            publishedVersion: 45,
                            revision: 14,
                            contentType: {
                              sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'contactUsCardComponent'
                              }
                            },
                            locale: 'en-US'
                          },
                          fields: {
                            title: 'Care Team Contact Us Card - US',
                            headline: 'To place an order or for support',
                            message: {
                              nodeType: 'document',
                              data: {},
                              content: [
                                {
                                  nodeType: 'paragraph',
                                  data: {},
                                  content: [
                                    {
                                      nodeType: 'text',
                                      value: '1-866-MODERNA (1-866-663-3762)',
                                      marks: [],
                                      data: {}
                                    }
                                  ]
                                },
                                {
                                  nodeType: 'paragraph',
                                  data: {},
                                  content: [
                                    {
                                      nodeType: 'text',
                                      value: '8:00AM - 8:00PM, Monday - Friday',
                                      marks: [],
                                      data: {}
                                    }
                                  ]
                                },
                                {
                                  nodeType: 'paragraph',
                                  data: {},
                                  content: [
                                    {
                                      nodeType: 'text',
                                      value: 'WeCare@modernatx.com',
                                      marks: [],
                                      data: {}
                                    }
                                  ]
                                },
                                {
                                  nodeType: 'paragraph',
                                  data: {},
                                  content: [
                                    {
                                      nodeType: 'text',
                                      value: '\n',
                                      marks: [],
                                      data: {}
                                    }
                                  ]
                                }
                              ]
                            },
                            icon: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                type: 'Asset',
                                createdAt: '2022-10-28T13:45:09.591Z',
                                updatedAt: '2022-12-09T19:13:58.864Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 11,
                                revision: 2,
                                locale: 'en-US'
                              },
                              fields: {
                                title: 'Faq Category Icon',
                                description: 'Faq Category SVG',
                                file: {
                                  url: prophylacticVaccinesIcon,
                                  details: {
                                    size: 40893,
                                    image: {
                                      width: 600,
                                      height: 600
                                    }
                                  },
                                  fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                  contentType: 'image/png'
                                }
                              }
                            },
                            country: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'ContentType',
                                    id: 'country'
                                  }
                                },
                                locale: 'en-US'
                              },
                              fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                  metadata: {
                                    tags: [],
                                    concepts: []
                                  },
                                  sys: {
                                    space: {
                                      sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                      }
                                    },
                                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                                    type: 'Asset',
                                    createdAt: '2023-05-24T22:54:50.939Z',
                                    updatedAt: '2023-05-24T22:54:50.939Z',
                                    environment: {
                                      sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                      }
                                    },
                                    publishedVersion: 5,
                                    revision: 1,
                                    locale: 'en-US'
                                  },
                                  fields: {
                                    title: 'usa flag',
                                    description: 'USA Flag',
                                    file: {
                                      url: usaFlag,
                                      details: {
                                        size: 2487,
                                        image: {
                                          width: 36,
                                          height: 26
                                        }
                                      },
                                      fileName: 'usa_flag.svg',
                                      contentType: 'image/svg+xml'
                                    }
                                  }
                                },
                                locales: [
                                  'en-US'
                                ]
                              }
                            }
                          }
                        },
                        {
                          metadata: {
                            tags: [],
                            concepts: []
                          },
                          sys: {
                            space: {
                              sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                              }
                            },
                            id: '7wREbh7uFf1amAX5Occ9dj',
                            type: 'Entry',
                            createdAt: '2022-12-02T04:28:54.232Z',
                            updatedAt: '2024-12-13T22:26:19.433Z',
                            environment: {
                              sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                              }
                            },
                            publishedVersion: 31,
                            revision: 10,
                            contentType: {
                              sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'contactUsCardComponent'
                              }
                            },
                            locale: 'en-US'
                          },
                          fields: {
                            title: 'Report Adverse Event Contact Us Card - US',
                            headline: 'Report an adverse event',
                            message: {
                              data: {},
                              content: [
                                {
                                  data: {},
                                  content: [
                                    {
                                      data: {},
                                      marks: [],
                                      value: 'Click the arrow to submit an adverse event report',
                                      nodeType: 'text'
                                    },
                                    {
                                      data: {},
                                      marks: [],
                                      value: '\n',
                                      nodeType: 'text'
                                    }
                                  ],
                                  nodeType: 'paragraph'
                                }
                              ],
                              nodeType: 'document'
                            },
                            icon: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                type: 'Asset',
                                createdAt: '2022-10-28T13:45:09.591Z',
                                updatedAt: '2022-12-09T19:13:58.864Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 11,
                                revision: 2,
                                locale: 'en-US'
                              },
                              fields: {
                                title: 'Faq Category Icon',
                                description: 'Faq Category SVG',
                                file: {
                                  url: prophylacticVaccinesIcon,
                                  details: {
                                    size: 40893,
                                    image: {
                                      width: 600,
                                      height: 600
                                    }
                                  },
                                  fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                  contentType: 'image/png'
                                }
                              }
                            },
                            link: {
                              sys: {
                                type: 'Link',
                                linkType: 'Entry',
                                id: '6mzHEzPj12cIX1TCNBE7p2'
                              }
                            },
                            country: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'ContentType',
                                    id: 'country'
                                  }
                                },
                                locale: 'en-US'
                              },
                              fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                  metadata: {
                                    tags: [],
                                    concepts: []
                                  },
                                  sys: {
                                    space: {
                                      sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                      }
                                    },
                                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                                    type: 'Asset',
                                    createdAt: '2023-05-24T22:54:50.939Z',
                                    updatedAt: '2023-05-24T22:54:50.939Z',
                                    environment: {
                                      sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                      }
                                    },
                                    publishedVersion: 5,
                                    revision: 1,
                                    locale: 'en-US'
                                  },
                                  fields: {
                                    title: 'usa flag',
                                    description: 'USA Flag',
                                    file: {
                                      url: usaFlag,
                                      details: {
                                        size: 2487,
                                        image: {
                                          width: 36,
                                          height: 26
                                        }
                                      },
                                      fileName: 'usa_flag.svg',
                                      contentType: 'image/svg+xml'
                                    }
                                  }
                                },
                                locales: [
                                  'en-US'
                                ]
                              }
                            },
                            label: 'Report an adverse event'
                          }
                        },
                        {
                          metadata: {
                            tags: [],
                            concepts: []
                          },
                          sys: {
                            space: {
                              sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                              }
                            },
                            id: '46fjepI7RrVzgj8ua6WqFv',
                            type: 'Entry',
                            createdAt: '2022-12-02T04:29:45.465Z',
                            updatedAt: '2024-12-13T22:25:31.150Z',
                            environment: {
                              sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                              }
                            },
                            publishedVersion: 14,
                            revision: 4,
                            contentType: {
                              sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'contactUsCardComponent'
                              }
                            },
                            locale: 'en-US'
                          },
                          fields: {
                            title: 'FAQ Contact Us Card - US',
                            headline: 'FAQs',
                            message: {
                              data: {},
                              content: [
                                {
                                  data: {},
                                  content: [
                                    {
                                      data: {},
                                      marks: [],
                                      value: 'Frequently asked questions about Moderna Direct\n\n',
                                      nodeType: 'text'
                                    }
                                  ],
                                  nodeType: 'paragraph'
                                }
                              ],
                              nodeType: 'document'
                            },
                            icon: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '2wQ7GSaGNr9QsirrrDwWrJ',
                                type: 'Asset',
                                createdAt: '2022-10-28T13:45:09.591Z',
                                updatedAt: '2022-12-09T19:13:58.864Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 11,
                                revision: 2,
                                locale: 'en-US'
                              },
                              fields: {
                                title: 'Faq Category Icon',
                                description: 'Faq Category SVG',
                                file: {
                                  url: prophylacticVaccinesIcon,
                                  details: {
                                    size: 40893,
                                    image: {
                                      width: 600,
                                      height: 600
                                    }
                                  },
                                  fileName: 'Moderna_Icon_ProphylacticVaccines.png',
                                  contentType: 'image/png'
                                }
                              }
                            },
                            link: {
                              sys: {
                                type: 'Link',
                                linkType: 'Entry',
                                id: '4sGXFZd1qHOz98lelP3ptv'
                              }
                            },
                            country: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '7sht7920U6vs3CLH2CUyaa',
                                type: 'Entry',
                                createdAt: '2023-05-18T03:23:50.744Z',
                                updatedAt: '2023-05-24T22:55:23.250Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 6,
                                revision: 2,
                                contentType: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'ContentType',
                                    id: 'country'
                                  }
                                },
                                locale: 'en-US'
                              },
                              fields: {
                                name: 'United States',
                                isocode: 'US',
                                flag: {
                                  metadata: {
                                    tags: [],
                                    concepts: []
                                  },
                                  sys: {
                                    space: {
                                      sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                      }
                                    },
                                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                                    type: 'Asset',
                                    createdAt: '2023-05-24T22:54:50.939Z',
                                    updatedAt: '2023-05-24T22:54:50.939Z',
                                    environment: {
                                      sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                      }
                                    },
                                    publishedVersion: 5,
                                    revision: 1,
                                    locale: 'en-US'
                                  },
                                  fields: {
                                    title: 'usa flag',
                                    description: 'USA Flag',
                                    file: {
                                      url: usaFlag,
                                      details: {
                                        size: 2487,
                                        image: {
                                          width: 36,
                                          height: 26
                                        }
                                      },
                                      fileName: 'usa_flag.svg',
                                      contentType: 'image/svg+xml'
                                    }
                                  }
                                },
                                locales: [
                                  'en-US'
                                ]
                              }
                            },
                            label: 'View Frequently Asked Questions'
                          }
                        },
                        {
                          metadata: {
                            tags: [],
                            concepts: []
                          },
                          sys: {
                            space: {
                              sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                              }
                            },
                            id: '1UNli48LSxpoJIrKw23H1N',
                            type: 'Entry',
                            createdAt: '2022-12-02T04:19:00.121Z',
                            updatedAt: '2023-09-28T16:53:26.696Z',
                            environment: {
                              sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                              }
                            },
                            publishedVersion: 28,
                            revision: 5,
                            contentType: {
                              sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'contactUsFormComponent'
                              }
                            },
                            locale: 'en-US'
                          },
                          fields: {
                            title: 'Contact Us Form Component',
                            headline: 'Ask a Question or Request to be Contacted',
                            message: {
                              nodeType: 'document',
                              data: {},
                              content: [
                                {
                                  nodeType: 'paragraph',
                                  data: {},
                                  content: [
                                    {
                                      nodeType: 'text',
                                      value: 'Enter your contact details and select how we can help you.',
                                      marks: [],
                                      data: {}
                                    }
                                  ]
                                }
                              ]
                            },
                            fullNameLabel: 'Full Name',
                            fullNamePlaceholder: 'Enter full name',
                            emailLabel: 'Email',
                            emailPlaceholder: 'Enter email',
                            phoneLabel: 'Phone',
                            phonePlaceholder: 'Enter phone',
                            organizationLabel: 'Organization',
                            organizationPlaceholder: 'Enter organization',
                            preferredMethodLabel: 'Preferred method of contact',
                            preferredMethodList: [
                              'Email',
                              'Phone'
                            ],
                            supportCategoryLabel: 'What can we help you with?',
                            supportCategoryList: [
                              'Contract and Billing',
                              'Order Assistance',
                              'Product Inquiry',
                              'Account Information',
                              'General Inquiry',
                              'Other'
                            ],
                            consentMessageLabel: 'I consent to the Moderna',
                            consentLink: {
                              sys: {
                                type: 'Link',
                                linkType: 'Entry',
                                id: '556dZCOMwLIKu69guk6x42'
                              }
                            }
                          }
                        },
                        {
                          metadata: {
                            tags: [],
                            concepts: []
                          },
                          sys: {
                            space: {
                              sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                              }
                            },
                            id: '7oSmj9Iyl3kSocc335XV51',
                            type: 'Entry',
                            createdAt: '2022-12-02T04:21:30.182Z',
                            updatedAt: '2022-12-02T04:21:30.182Z',
                            environment: {
                              sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                              }
                            },
                            publishedVersion: 8,
                            revision: 1,
                            contentType: {
                              sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'contactUsConfirmationComponent'
                              }
                            },
                            locale: 'en-US'
                          },
                          fields: {
                            title: 'Contact Us Confirmation Component',
                            headline: 'Request Sent',
                            message: {
                              data: {},
                              content: [
                                {
                                  data: {},
                                  content: [
                                    {
                                      data: {},
                                      marks: [],
                                      value: 'Thank you for reaching out. A representative will reach out shortly.',
                                      nodeType: 'text'
                                    }
                                  ],
                                  nodeType: 'paragraph'
                                }
                              ],
                              nodeType: 'document'
                            },
                            icon: {
                              metadata: {
                                tags: [],
                                concepts: []
                              },
                              sys: {
                                space: {
                                  sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                  }
                                },
                                id: '5EWJeaSLcAOTh1XGB5J1Jd',
                                type: 'Asset',
                                createdAt: '2022-11-08T22:15:01.982Z',
                                updatedAt: '2022-11-08T22:15:01.982Z',
                                environment: {
                                  sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                  }
                                },
                                publishedVersion: 3,
                                revision: 1,
                                locale: 'en-US'
                              },
                              fields: {
                                title: 'webimage-13968D71-F252-482D-8242F0F417213C5F',
                                description: '',
                                file: {
                                  url: noteScroll,
                                  details: {
                                    size: 35738,
                                    image: {
                                      width: 600,
                                      height: 600
                                    }
                                  },
                                  fileName: 'webimage-13968D71-F252-482D-8242F0F417213C5F.png',
                                  contentType: 'image/png'
                                }
                              }
                            },
                            link: {
                              sys: {
                                type: 'Link',
                                linkType: 'Entry',
                                id: '7sOHpLfHcBdXJkB7vOBL26'
                              }
                            }
                          }
                        }
                      ]
                    }
                  }
                }
              }
            }
          },
          backgroundImage: {
            metadata: {
              tags: [],
              concepts: []
            },
            sys: {
              space: {
                sys: {
                  type: 'Link',
                  linkType: 'Space',
                  id: 'n9bebhw263o0'
                }
              },
              id: '4udXXZnb6huWaP2x7gPRJO',
              type: 'Asset',
              createdAt: '2022-10-31T05:40:17.871Z',
              updatedAt: '2022-10-31T05:40:17.871Z',
              environment: {
                sys: {
                  id: 'sandbox',
                  type: 'Link',
                  linkType: 'Environment'
                }
              },
              publishedVersion: 3,
              revision: 1,
              locale: 'en-US'
            },
            fields: {
              title: 'Banner BG Strand Bottom',
              description: '',
              file: {
                url: bannerStrandBottom,
                details: {
                  size: 26282,
                  image: {
                    width: 1920,
                    height: 324
                  }
                },
                fileName: 'Banner BG Strand Bottom.png',
                contentType: 'image/png'
              }
            }
          }
        }
      }
    }